import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,

  props: {
    labels: {
      type: Array,
      default: []
    },
    datasets: {
      type: Array,
      default: []
    }
  },

  data () {
    return {
      chartdata: {
        labels: this.labels,
        datasets: this.datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
       /* scales: {
          xAxes: [{
            display: false
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }*/
      }
    }
  },

  mounted () {
    this.renderChart(this.chartdata, this.options)
  }
}
